export const initialState = {
  user: null,
  upcomingProvider: [],
  recentProvider: {},
  notifCount: 0,
};
